export const GTMBodyScript = () => {
  const script = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  const gtmId = process.env['NX_GTM_SCRIPT_ID'];
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.setAttribute('style', 'display:none;visibility:hidden');
  script.appendChild(iframe);

  return script;
};
